<template>
	<div class="noData flex-center flex-column">
		<img src="@/assets/images/noData.png">
		<div class="text" :style="{color}" v-if="text">{{text}}</div>
	</div>
</template>

<script setup>
	let props = defineProps({
		text:{
			type:String,
			default:'',
		},
		color:{
			type:String,
			default:'#111',
		}
	})
</script>

<style lang="scss" scoped>
	.noData{
		width: 100%;
	}
</style>